export class Lang {
    replaceQueryParam(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');
        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval
            : '');
    }

    async action_lang() {
        const language = document.getElementsByName('Lang')[0].value;
        await BX.ajax.runComponentAction('maxcrm:language', 'setLanguage', { mode: 'class', data: { language: language } })
        location.reload()
    }

    async insertLanguageSelector()
    {
        const { data: currentLang } = await BX.ajax.runComponentAction('maxcrm:language', 'getCurrentLanguage', { mode: 'class' });
        const container = document.querySelector('#copyright')
        if(container) {
            const switcher = document.querySelector('#setLanguageAction');
            if(!switcher) {
                let languageSelector = "<div id='maxcrmLangSwitcher' class='ui-ctl ui-ctl-inline ui-ctl-wa ui-ctl-after-icon ui-ctl-dropdown'><div class=\"ui-ctl-after ui-ctl-icon-angle\"></div>" +
                    "<select name='Lang' onchange='new BX.Maxcrm.Lang().action_lang()' class=\"ui-ctl-element maxCrmSelector-l\">";
                const languages = await this._getLangs()
                languages.forEach((language) => {
                    const selected = currentLang === language.CODE ? 'selected' : '';
                    languageSelector += "<option value=\"" + language.CODE + "\" " + selected +">" + language.NAME + "</option>";
                })
                languageSelector += "</select></div>"
                container.prepend(this._createElementFromHTML(languageSelector));
            }
        }
    }


    async _getLangs()
    {
        const response = await BX.ajax.runComponentAction('maxcrm:language', 'getLanguages', {
            mode: 'class'
        })
        return response.data
    }

    _createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        return div.firstChild;
    }
}

BX.ready(() => {
    new BX.Maxcrm.Lang().insertLanguageSelector()
})